import { render, staticRenderFns } from "./Tournament.vue?vue&type=template&id=034e19c9&scoped=true"
import script from "./Tournament.vue?vue&type=script&lang=js"
export * from "./Tournament.vue?vue&type=script&lang=js"
import style0 from "./Tournament.vue?vue&type=style&index=0&id=034e19c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034e19c9",
  null
  
)

export default component.exports